module.exports = __webpack_public_path__ + "assets/img/35_1117.ca5677c1.jpg";